module.exports = function getResource(label, vars = []) {
    const resources = {
        edit: 'Edit',
        add: 'Add',
        editAddCreditCard: `${vars[0] ? 'Edit' : 'Add'} Credit or Debit Card`,
        cardType: 'Card type',
        cardTypeRequired: 'Card type required.',
        cardNumber: 'Card number',
        cardNumberRequired: 'Credit card number required.',
        expirationMonth: 'Expiration month',
        expirationMonthRequired: 'Expiration month required.',
        expirationYear: 'Expiration year',
        expirationYearRequired: 'Expiration year required.',
        setAsDefaultCreditCard: 'Set as my default card',
        deleteCreditCard: 'Delete card',
        cancel: 'Cancel',
        update: 'Update',
        save: 'Save',
        areYouSureYouWouldLikeToDelete: 'Are you sure you would like to permanently delete your card?',
        yes: 'Yes',
        no: 'No',
        debitCardDisclaimer: 'Visa and Mastercard debit cards only'
    };
    return resources[label];
};
